import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';
import {FormControlBase} from '../form-control-base';

@Component({
  selector: 'app-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrls: ['./input-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckboxComponent),
      multi: true
    }
  ]
})
export class InputCheckboxComponent extends FormControlBase<any> implements OnInit {

  @Input() id;
  @Input() label;
  @Input() name;
  @Input() checkboxVal;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) { super(cc); }

  ngOnInit() {
    this.checkInitialControl();
  }

}
